import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 18.1 18.3"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "7.5",
      cy: "7.5",
      r: "7.5",
      fill: "none",
      class: "i-593427446__st0",
      "vector-effect": "non-scaling-stroke"
    }, null, -1),
    _createElementVNode("path", {
      d: "m12.7 12.8 5.4 5.5",
      class: "i-593427446__st0",
      "vector-effect": "non-scaling-stroke"
    }, null, -1)
  ]))]))
}
export default { render: render }